import { useState } from 'react';
import './PatentApplicationsListItem.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { Link } from 'react-router-dom';

export default function PatentApplicationsListItem({user, applicationItem, updateApplications, patentApplicationPreferences, isMobile, toggleNotifications}) {
    const noteLimit = 10
    const [showMoreNote, setShowMoreNote] = useState(false)
    const handleShowMoreNote = () => {
        setShowMoreNote(!showMoreNote)
    }

    return (
    <tr className={`PatentApplicationsListItem ${applicationItem.applicationStatus? applicationItem.applicationStatus:''}`}>
        {!patentApplicationPreferences.includes('RPNumber') &&
        <td className='RPNumber'>
            {applicationItem.RPNumber? 
            <Link to={`/applications/patent/${applicationItem._id}`}>
                {applicationItem.RPNumber}
            </Link>
            :
            '---'
            }
        </td>
        }
        {!patentApplicationPreferences.includes('applicationNumber') &&
        <td className='applicationNumber'>
            {applicationItem.applicationNumber? applicationItem.applicationNumber:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('applicationType') &&
        <td className='applicationType'>
            {applicationItem.applicationType?
            <>
            {applicationItem.applicationType === 'nonProvisional' ? 'Non-Provisional' : capitalizeFirstLetter(applicationItem.applicationType)}
            </>
            :
            '---'
            }
        </td>
        }
        {!patentApplicationPreferences.includes('filingDate') &&
        <td className='filingDate dateField'>
            <div>
                {applicationItem.filingDate? new Date(applicationItem.filingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('title') &&
        <td className='title'>
            {applicationItem.title? capitalizeFirstLetter(applicationItem.title):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('applicationStatus') &&
        <td className='applicationStatus'>
            {applicationItem.applicationStatus? 
            <>
            {applicationItem.applicationStatus === 'officeActionIssued' ? 'Office Action Issued' : applicationItem.applicationStatus === 'NOAIssued' ? 'NOA Issued' : applicationItem.applicationStatus === 'awaitingExam' ? 'Awaiting Exam' : capitalizeFirstLetter(applicationItem.applicationStatus)}
            </>
            :'---'
            }
        </td>
        }
        {!patentApplicationPreferences.includes('inventors') &&
        <td className='inventors'>
            {applicationItem.inventors? capitalizeFirstLetter(applicationItem.inventors):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('clientName') &&
        <td className='clientName'>
            {applicationItem.clientName? capitalizeFirstLetter(applicationItem.clientName):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('clientID') &&
        <td className='clientID'>
            {applicationItem.clientID? applicationItem.clientID:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('applicants') &&
        <td className='applicants'>
            {applicationItem.applicants? capitalizeFirstLetter(applicationItem.applicants):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('filingFirm') &&
        <td className='filingFirm'>
            {applicationItem.filingFirm? capitalizeFirstLetter(applicationItem.filingFirm):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('firmRefNumber') &&
        <td className='firmRefNumber'>
            {applicationItem.firmRefNumber? applicationItem.firmRefNumber:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('attorney') &&
        <td className='attorney'>
            {applicationItem.attorney? capitalizeFirstLetter(applicationItem.attorney):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('attorneyRefNumber') &&
        <td className='attorneyRefNumber'>
            {applicationItem.attorneyRefNumber? applicationItem.attorneyRefNumber:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('contact') &&
        <td className='contact'>
            {applicationItem.contact? capitalizeFirstLetter(applicationItem.contact):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('country') &&
        <td className='country'>
            {applicationItem.country? applicationItem.country.toUpperCase():'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('patentType') &&
        <td className='patentType'>
            {applicationItem.patentType? capitalizeFirstLetter(applicationItem.patentType):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('earliestPriorityDate') &&
        <td className='earliestPriorityDate dateField'>
            <div>
                {applicationItem.earliestPriorityDate? new Date(applicationItem.earliestPriorityDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('earliestPriorityApplicationNumber') &&
        <td className='earliestPriorityApplicationNumber'>
            {applicationItem.earliestPriorityApplicationNumber? applicationItem.earliestPriorityApplicationNumber:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('lastAction') &&
        <td className='lastAction'>
            {applicationItem.lastAction? applicationItem.lastAction:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('nextAction') &&
        <td className='nextAction'>
            {applicationItem.nextAction? applicationItem.nextAction:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('nextActionDueDate') &&
        <td className='nextActionDueDate dateField'>
            <div>
                {applicationItem.nextActionDueDate? new Date(applicationItem.nextActionDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('entityStatus') &&
        <td className='entityStatus'>
            {applicationItem.entityStatus? capitalizeFirstLetter(applicationItem.entityStatus):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('plannedFilingDate') &&
        <td className='plannedFilingDate dateField'>
            <div>
                {applicationItem.plannedFilingDate? new Date(applicationItem.plannedFilingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('officialFilingDate') &&
        <td className='officialFilingDate dateField'>
            <div>
                {applicationItem.officialFilingDate? new Date(applicationItem.officialFilingDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('nationalEntryDate') &&
        <td className='nationalEntryDate dateField'>
            <div>
                {applicationItem.nationalEntryDate? new Date(applicationItem.nationalEntryDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('publicationDate') &&
        <td className='publicationDate dateField'>
            <div>
                {applicationItem.publicationDate? new Date(applicationItem.publicationDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('estimatedFirstOfficeActionDate') &&
        <td className='estimatedFirstOfficeActionDate dateField'>
            <div>
                {applicationItem.estimatedFirstOfficeActionDate? new Date(applicationItem.estimatedFirstOfficeActionDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('officialOfficeActionDate') &&
        <td className='officialOfficeActionDate dateField'>
            <div>
                {applicationItem.officialOfficeActionDate? new Date(applicationItem.officialOfficeActionDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('allowanceDate') &&
        <td className='allowanceDate dateField'>
            <div>
                {applicationItem.allowanceDate? new Date(applicationItem.allowanceDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('requestExaminerInterview') &&
        <td className='requestExaminerInterview'>
            {applicationItem.requestExaminerInterview? capitalizeFirstLetter(applicationItem.requestExaminerInterview):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('examinerInterviewDate') &&
        <td className='examinerInterviewDate dateField'>
            <div>
                {applicationItem.examinerInterviewDate? new Date(applicationItem.examinerInterviewDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('filedRCE') &&
        <td className='filedRCE'>
            {applicationItem.filedRCE? capitalizeFirstLetter(applicationItem.filedRCE):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('RCEFiledDate') &&
        <td className='RCEFiledDate dateField'>
            <div>
                {applicationItem.RCEFiledDate? new Date(applicationItem.RCEFiledDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('issueFeePaymentDate') &&
        <td className='issueFeePaymentDate dateField'>
            <div>
                {applicationItem.issueFeePaymentDate? new Date(applicationItem.issueFeePaymentDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('issueDate') &&
        <td className='issueDate dateField'>
            <div>
                {applicationItem.issueDate? new Date(applicationItem.issueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('patentNumber') &&
        <td className='patentNumber'>
            {applicationItem.patentNumber? applicationItem.patentNumber:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('maintenanceFeeDueDate') &&
        <td className='maintenanceFeeDueDate dateField'>
            <div>
                {applicationItem.maintenanceFeeDueDate? new Date(applicationItem.maintenanceFeeDueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('maintenanceFeeStatus') &&
        <td className='maintenanceFeeStatus'>
            {applicationItem.maintenanceFeeStatus? capitalizeFirstLetter(applicationItem.maintenanceFeeStatus):'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('expirationDate') &&
        <td className='expirationDate dateField'>
            <div>
                {applicationItem.expirationDate? new Date(applicationItem.expirationDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('abandonedDate') &&
        <td className='abandonedDate dateField'>
            <div>
                {applicationItem.abandonedDate? new Date(applicationItem.abandonedDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('PAIRReg') &&
        <td className='PAIRReg'>
            {applicationItem.PAIRReg? applicationItem.PAIRReg:'---'}
        </td>
        }
        {!patentApplicationPreferences.includes('notes') &&
        <td className='notes'>
            { showMoreNote ? 
            <>
            <span>{applicationItem.note? `${applicationItem.note}` : '---'}</span>
            { applicationItem.note && applicationItem.note.length > noteLimit &&
            <>
            <span>&nbsp;</span>
            <span className='limitText' onClick={handleShowMoreNote}>View Less</span>
            </>
            }
            </>
            : 
            <>
            <span>{applicationItem.note? `${applicationItem.note.substring(0, noteLimit)}`: '---'}</span>
            { applicationItem.note && applicationItem.note.length > noteLimit &&
            <>
            <span className='primaryText'>&nbsp;...</span>
            <span className='limitText' onClick={handleShowMoreNote}>View More</span>
            </>
            }
            </>
            }
        </td>
        }
        {!patentApplicationPreferences.includes('driveFolderLocation') &&
        <td className='driveFolderLocation'>
            {applicationItem.driveFolderLocation? 
            <a href={applicationItem.driveFolderLocation.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        {!patentApplicationPreferences.includes('createdAt') &&
        <td className='createdAt dateField'>
            <div>
                {applicationItem.createdAt? new Date(applicationItem.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
        {!patentApplicationPreferences.includes('updatedAt') &&
        <td className='updatedAt dateField'>
            <div>
                {applicationItem.updatedAt? new Date(applicationItem.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }):'---'}
            </div>
        </td>
        }
    </tr>
  )
}
